import Controller from "./class.Controller";
import TransporterLog from "./class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterStorage",
		color: "orange",
	},
});

/**
 * A class which abstracts away storage needs.
 * Uses localStorage at the moment, but might use
 * ajax in the future.
 */
export default class TransporterStorage extends Controller {
	constructor(options) {
		super(options);

		this.enabled = false;
		this.prefix = "transporter-";
		if ("localStorage" in window) {
			LOGGER.log("Local storage enabled.");
			this.enabled = true;
			this.localStorage = window.localStorage;
		}
	}

	/**
	 * Stores a key value pair.
	 * Key is automatically prefixed with "transporter-".
	 *
	 * @param {string} key
	 * @param {string} value
	 * @param {boolean} [prefix]
	 */
	set(key, value, prefix = true) {
		if (this.enabled) {
			try {
				this.localStorage.setItem(`${prefix ? this.prefix : ""}${key}`, value);
			} catch (e) {
				LOGGER.error("Failed to save item to local storage.");
			}
		}
	}

	/**
	 * Gets a value.
	 * Key is automatically prefixed with "transporter-".
	 *
	 * @param {string} key
	 * @param {boolean} [prefix]
	 * @returns string or null if failure.
	 */
	get(key, prefix = true) {
		if (this.enabled) {
			try {
				return this.localStorage.getItem(`${prefix ? this.prefix : ""}${key}`);
			} catch (e) {
				LOGGER.error("Failed to get item from local storage.");
			}
		}
		return null;
	}

	/**
	 * Removes a value.
	 * Key is automatically prefixed with "transporter-".
	 *
	 * @param {string} key
	 * @param {boolean} [prefix]
	 */
	remove(key, prefix = true) {
		if (this.enabled) {
			try {
				return this.localStorage.removeItem(
					`${prefix ? this.prefix : ""}${key}`
				);
			} catch (e) {
				LOGGER.error("Failed to remove item from local storage.");
			}
		}
	}
}
